export default "__VITE_ASSET__ow6tzI80__"